import { render, staticRenderFns } from "./cdConfigInfos.vue?vue&type=template&id=08574b34&scoped=true"
import script from "./cdConfigInfos.vue?vue&type=script&lang=js"
export * from "./cdConfigInfos.vue?vue&type=script&lang=js"
import style0 from "./cdConfigInfos.vue?vue&type=style&index=0&id=08574b34&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08574b34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08574b34')) {
      api.createRecord('08574b34', component.options)
    } else {
      api.reload('08574b34', component.options)
    }
    module.hot.accept("./cdConfigInfos.vue?vue&type=template&id=08574b34&scoped=true", function () {
      api.rerender('08574b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_gd_details/form/components/cdConfigInfos.vue"
export default component.exports